import { Check, X, MoreHorizontal, Flag, MessageSquare } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { LeadTableRow } from '@/services/mockLeads'

interface LeadActionButtonsProps {
  lead: LeadTableRow
  onApprove: (leadId: string) => void
  onReject: (leadId: string) => void
  onFlag: (leadId: string) => void
  onNote: (leadId: string) => void
  disabled?: boolean
  compact?: boolean
}

export function LeadActionButtons({
  lead,
  onApprove,
  onReject,
  onFlag,
  onNote,
  disabled = false,
  compact = false
}: LeadActionButtonsProps) {
  if (lead.status !== 'pending') {
    return (
      <div className="text-xs text-muted-foreground">
        {lead.reviewedBy && `By ${lead.reviewedBy}`}
      </div>
    )
  }
  
  if (compact) {
    return (
      <div className="flex items-center gap-1">
        <Button
          size="sm"
          variant="outline"
          onClick={() => onApprove(lead.id)}
          disabled={disabled}
          className="h-7 px-2 text-green-600 hover:bg-green-50"
        >
          <Check className="h-3 w-3" />
        </Button>
        
        <Button
          size="sm"
          variant="outline"
          onClick={() => onReject(lead.id)}
          disabled={disabled}
          className="h-7 px-2 text-red-600 hover:bg-red-50"
        >
          <X className="h-3 w-3" />
        </Button>
        
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button
              size="sm"
              variant="ghost"
              disabled={disabled}
              className="h-7 w-7 p-0"
            >
              <MoreHorizontal className="h-3 w-3" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuItem onClick={() => onFlag(lead.id)}>
              <Flag className="h-4 w-4 mr-2" />
              Flag for Review
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => onNote(lead.id)}>
              <MessageSquare className="h-4 w-4 mr-2" />
              Add Note
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    )
  }
  
  return (
    <div className="flex items-center gap-2">
      <Button
        size="sm"
        variant="outline"
        onClick={() => onApprove(lead.id)}
        disabled={disabled}
        className="text-green-600 hover:bg-green-50 border-green-200"
      >
        <Check className="h-4 w-4 mr-1" />
        Approve
      </Button>
      
      <Button
        size="sm"
        variant="outline"
        onClick={() => onReject(lead.id)}
        disabled={disabled}
        className="text-red-600 hover:bg-red-50 border-red-200"
      >
        <X className="h-4 w-4 mr-1" />
        Reject
      </Button>
      
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            size="sm"
            variant="ghost"
            disabled={disabled}
          >
            <MoreHorizontal className="h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem onClick={() => onFlag(lead.id)}>
            <Flag className="h-4 w-4 mr-2" />
            Flag for Review
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => onNote(lead.id)}>
            <MessageSquare className="h-4 w-4 mr-2" />
            Add Note
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem>
            View Details
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  )
}